export { default as LifestylesIndexPageCategoriesNavList } from './LifestylesIndexPageCategoriesNavList';
